import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import PolicyDetails from '@/models/PolicyDetails';
import IManufacturer from '@/models/vehicle/interfaces/manufacturer.d';
import IRange from '@/models/vehicle/interfaces/range.d';
import IDerivative from '@/models/vehicle/interfaces/derivative.d';
import IPostEnquiryState from './interfaces/post-enquiry-state.d';

export default class PostEnquiryState implements IPostEnquiryState {
    public enquiryId!: number;
    
    public enquiryReferenceCode!: string;

    public enquiryVehicles!: IVehicle[];

    public policyDetails!: PolicyDetails[];

    public manufacturers: IManufacturer[] | null = null;

    public ranges: IRange[] | null = null;

    public derivatives: IDerivative[] | null = null;
}
